import React, { useState, useEffect } from "react";
import MessengerLayout from "../../layout/MessengerLayout";
import AttendanceStats    from "../../components/attendance/AttendanceStats";
import AttendanceCalendar from "../../components/attendance/AttendanceCalendar";
import AttendanceTable    from "../../components/attendance/AttendanceTable";
import RegularisationModal from "../../components/attendance/RegularisationModal";
import MySchedulePage from "../rota/MySchedulePage";

export default function AttendanceMessengerPage() {
  const [tab, setTab]                 = useState("attendance");  // attendance | schedule
  const [showModal, setShowModal]     = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  // Bumping this `key` value remounts the data-owning children so they
  // re-fetch — used to react to K.I.R.A action completion events.
  const [kiraVersion, setKiraVersion] = useState(0);

  useEffect(() => {
    const handleKiraAction = (e) => {
      const t = e.detail?.action_type || "";
      if (["attendance_checkin", "attendance_checkout", "attendance_regularise"].includes(t)) {
        setKiraVersion(v => v + 1);
      }
    };
    window.addEventListener("kira_action_complete", handleKiraAction);
    return () => window.removeEventListener("kira_action_complete", handleKiraAction);
  }, []);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    setShowModal(true);
  };

  return (
    <MessengerLayout>
      <div className="p-6 space-y-5 text-white">

        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#00ff90]">Attendance</h1>
            <p className="text-white/40 text-sm mt-0.5">Your attendance snapshot, calendar and history</p>
          </div>
          {tab === "attendance" && (
            <button
              onClick={() => { setSelectedDate(null); setShowModal(true); }}
              className="text-sm px-4 py-2 rounded-lg border border-[#00ff90]/30 bg-[#00ff90]/10 text-[#00ff90] hover:bg-[#00ff90]/20 transition-colors"
            >
              + Request Regularisation
            </button>
          )}
        </div>

        {/* Tabs */}
        <div className="flex gap-2 border-b border-white/5">
          {[["attendance", "Attendance"], ["schedule", "My Schedule"]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)}
              className={`px-4 py-2 text-sm transition-colors -mb-px border-b-2 ${
                tab === k ? "text-[#00ff90] border-[#00ff90]" : "text-white/50 border-transparent hover:text-white/80"
              }`}>
              {l}
            </button>
          ))}
        </div>

        {tab === "attendance" && (
          <>
            <AttendanceStats key={`stats-${kiraVersion}`} />
            {/* Calendar + Attendance Log — stacked full-width (calendar on top, log below) */}
            <div className="space-y-5">
              <div className="w-full">
                <AttendanceCalendar key={`cal-${kiraVersion}`} onDateClick={handleDateClick} />
              </div>
              <div className="w-full">
                <AttendanceTable key={`tbl-${kiraVersion}`} />
              </div>
            </div>
          </>
        )}

        {tab === "schedule" && (
          <MySchedulePage embedded={true} />
        )}

      </div>

      {/* Modal */}
      {showModal && (
        <RegularisationModal
          date={selectedDate}
          onClose={() => { setShowModal(false); setSelectedDate(null); }}
        />
      )}
    </MessengerLayout>
  );
}